import { useCall } from "@/context/CallContext";
import { Phone, PhoneSlash } from "@phosphor-icons/react";

export default function IncomingCallToast() {
  const { incomingCall, acceptIncoming, rejectIncoming } = useCall();
  if (!incomingCall) return null;

  const params = incomingCall.parameters || {};
  const from = params.From || "Unknown caller";

  return (
    <div
      className="fixed bottom-6 right-6 z-50 w-[320px] bg-white border-2 border-[var(--accent)] shadow-2xl"
      data-testid="incoming-call-toast"
    >
      <div className="px-4 py-3 border-b border-[var(--border)] bg-[var(--bg-sidebar)]">
        <div className="text-[11px] tracking-widest text-[var(--text-muted)] font-semibold">INCOMING CALL</div>
      </div>
      <div className="px-4 py-4">
        <div className="font-display text-[18px] font-bold" data-testid="incoming-call-name">
          {params.CallerName || "Caller"}
        </div>
        <div className="font-mono text-[14px] text-[var(--text-secondary)] mt-0.5" data-testid="incoming-call-from">
          {from}
        </div>
        <div className="flex gap-2 mt-4">
          <button
            onClick={rejectIncoming}
            data-testid="incoming-call-reject"
            className="flex-1 bg-[var(--danger)] hover:bg-[#DC2626] text-white py-2.5 flex items-center justify-center gap-2 font-semibold"
          >
            <PhoneSlash size={16} weight="fill" /> Reject
          </button>
          <button
            onClick={acceptIncoming}
            data-testid="incoming-call-accept"
            className="flex-1 bg-[#10B981] hover:bg-[#059669] text-white py-2.5 flex items-center justify-center gap-2 font-semibold ring-pulse"
          >
            <Phone size={16} weight="fill" /> Answer
          </button>
        </div>
      </div>
    </div>
  );
}
